import { Outlet } from "react-router-dom";

import { FilterTransactionProvider } from "./filter-transaction/filter-transaction.context";
import './transaction.scss';

export function Transaction() {
  return (
    <div id="ShellTransaction" className="transaction">
       <FilterTransactionProvider>
        <Outlet />
      </FilterTransactionProvider>
    </div>
  );
}

export default Transaction;
